import Plugin from '@jbrowse/core/Plugin';
import LinearArcDisplayF from './LinearArcDisplay';
import LinearPairedArcDisplayF from './LinearPairedArcDisplay';
import ArcRendererF from './ArcRenderer';
import { set1 } from '@jbrowse/core/ui/colors';
export default class ArcPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.name = 'ArcRenderer';
    }
    install(pluginManager) {
        ArcRendererF(pluginManager);
        LinearArcDisplayF(pluginManager);
        LinearPairedArcDisplayF(pluginManager);
        pluginManager.jexl.addFunction('logThickness', (feature, attributeName) => Math.log(feature.get(attributeName) + 1));
        pluginManager.jexl.addFunction('defaultPairedArcColor', (_feature, alt) => {
            if (alt === null || alt === void 0 ? void 0 : alt.startsWith('<DEL')) {
                return set1[0];
            }
            else if (alt === null || alt === void 0 ? void 0 : alt.startsWith('<DUP')) {
                return set1[1];
            }
            else if (alt === null || alt === void 0 ? void 0 : alt.startsWith('<INV')) {
                return set1[2];
            }
            else if (alt === null || alt === void 0 ? void 0 : alt.startsWith('<TRA')) {
                return set1[3];
            }
            else if (alt === null || alt === void 0 ? void 0 : alt.startsWith('<CNV')) {
                return set1[4];
            }
            else {
                return set1[6]; // skip 5, yellow
            }
        });
    }
}
